module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TkJWde/tc-custom/9781526729668.jpg?1703819676796",
      "alt": "This image is the cover for the book 1920"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1920\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“History writing at its best . . . teasing out extraordinary parallels between our current world and that of a century ago.” —Tim Butcher, author of "), _c('i', [_vm._v("Blood River")])]), _c('br'), _c('br'), _vm._v("A pandemic has killed millions. Violent uprisings are tearing apart the Middle East. Nationalism is on the march in Europe. An unlikely candidate is running for president in the US on a populist platform to put “America first.” The year is 1920. "), _c('br'), _c('br'), _c('i', [_vm._v("1920: A Year of Global Turmoil")]), _vm._v(" tells the story of twelve months that set in motion one hundred years of history. From America to Asia, the events of 1920 foreshadowed the decline of empires, the coming of another global conflict, and the rise of an American president who would change his country's relationship with the world. Weaving personal accounts with grand narrative, it vividly illuminates a past that echoes the present.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Charlwood\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("DAVID CHARLWOOD obtained a First Class Honours Degree in history from Royal Holloway, University of London, and has worked as an international journalist and in publishing. His research into the early Twentieth Century Middle East has been published in the British Journal of Middle Eastern Studies and he has written historical articles for a US-based think tank and contributed to BBC radio. 1920: A Year of Global Turmoil is his second book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword/Pen and Sword History\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0